// @flow

// Hocs
import bootingContainer from '../containers/Booting'

// Libs
import React from 'react'

// Local Types
type Props = {
  booting: boolean,
  children: ?React.Element<any>,
}

// Exports
export function Booting ({booting, children}: Props): ?React.Element<any> {
  if (booting) {
    return (
      <div>Loading...</div>
    )
  }

  return children
}

export default bootingContainer(Booting)
